import { Avatar } from '@/components';
import { Tooltip } from 'antd';
import React from 'react';

// Multiple avatars renderer
interface MultipleAvatarsRendererProps {
  users?: Array<{
    id?: string | number;
    userId?: string | number;
    userName?: string;
    userFullname?: string;
    name?: string;
    avatarUrl?: string;
    userAvatar?: string;
  }>;
  maxVisible?: number;
  size?: 'small' | 'default' | 'large' | number;
  showCount?: boolean;
  className?: string;
  showName?: boolean;
}

export const MultipleAvatarsRenderer: React.FC<MultipleAvatarsRendererProps> = ({
  users = [],
  maxVisible = 2,
  size = 'default',
  showCount = true,
  className = '',
  showName = false,
}) => {
  if (!users || users.length === 0) return null;

  const visibleUsers = users.slice(0, maxVisible);
  const remainingCount = users.length - maxVisible;
  const multipleAvatars = users.length > 1;
  const showTooltip = !showName || (showName && multipleAvatars);

  return showTooltip ? (
    <Tooltip
      title={
        <div>
          {users.map((user, idx) => (
            <div key={user.id || idx}>
              {user.userFullname || user.userName || user.name || 'Không rõ tên'}
            </div>
          ))}
        </div>
      }
      placement='top'
    >
      <div className={`multiple-avatars-renderer ${className}`}>
        {visibleUsers.map((user, index) => (
          <div key={user.id || index} className='multiple-avatars-renderer__item'>
            <Avatar
              userName={user.userFullname}
              size={size}
              className='multiple-avatars-renderer__avatar'
              src={user.avatarUrl || user.userAvatar}
            />
          </div>
        ))}
        {remainingCount > 0 && showCount && (
          <Avatar
            size={size}
            className='multiple-avatars-renderer__count'
            text={`+${remainingCount}`}
            style={{ backgroundColor: '#1890ff' }}
          ></Avatar>
        )}
      </div>
    </Tooltip>
  ) : (
    <div className={`multiple-avatars-renderer ${className}`}>
      {visibleUsers.map((user, index) => (
        <div key={user.id || index} className='multiple-avatars-renderer__item'>
          <Avatar
            userName={user.userFullname}
            size={size}
            className='multiple-avatars-renderer__avatar'
            src={user.avatarUrl || user.userAvatar}
          />
        </div>
      ))}
      {remainingCount > 0 && showCount && (
        <Avatar
          size={size}
          className='multiple-avatars-renderer__count'
          text={`+${remainingCount}`}
          style={{ backgroundColor: '#1890ff' }}
        ></Avatar>
      )}
      {showName && !multipleAvatars && (
        <span className='multiple-avatars-renderer__name'>{users[0].userFullname}</span>
      )}
    </div>
  );
};
